import { PropTypes } from 'prop-types';
import React from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import DateTimePicker from './DateTimePicker';

const AsOfDateForm = ({ onSubmit, onCancel, initialValues }) => {
  const methods = useForm({ defaultValues: initialValues || {} });

  return (
    <FormProvider {...methods}>
      <form className="form-inline" onSubmit={methods.handleSubmit(onSubmit)}>
        <Controller
          name="from"
          render={({ field }) => <DateTimePicker input={field} id="from" className="small-date" />}
        />
        <Controller
          name="until"
          render={({ field }) => <DateTimePicker input={field} id="until" className="small-date" />}
        />
        <button type="submit" className="button confirm ml-2">
          Ok
        </button>
        <button type="button" className="button ml-2" onClick={onCancel}>
          Cancel
        </button>
      </form>
    </FormProvider>
  );
};

AsOfDateForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({}),
};

export default AsOfDateForm;
